import React from 'react';
import { ThreeDots } from "react-loader-spinner";

export default function LoadingSpinner() {
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <div className="d-flex justify-content-center align-items-center" style={{height: '50vh'}}>
        <ThreeDots color="#00BFFF" height={80} width={80} />
      </div>
    </div>
  );
} 